/*
 * MonthlyReport Messages
 *
 * This contains all the text for the MonthlyReport component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  month: {
    id: 'app.containers.MonthlyReport.month',
    defaultMessage: 'Month',
  },
  year: {
    id: 'app.containers.MonthlyReport.year',
    defaultMessage: 'Year',
  },
  booksAndBiblePlacements: {
    id: 'app.containers.MonthlyReport.biblePlacements',
    defaultMessage: 'Books and bible placements',
  },
  downloadReport: {
    id: 'app.containers.MonthlyReport.downloadReport',
    defaultMessage: 'Download Report',
  },
  magazinBrochureTractPlacements: {
    id: 'app.containers.MonthlyReport.magazinePlacements',
    defaultMessage: 'Magazine, brochure, tract, and contact card placements',
  },
  videoShowings: {
    id: 'app.containers.MonthlyReport.videoShowings',
    defaultMessage: 'Video showings',
  },
  receivedAddresses: {
    id: 'app.containers.MonthlyReport.receivedAddresses',
    defaultMessage: 'Received addresses, phone or e-mail contacts',
  },
  heldConversations: {
    id: 'app.containers.MonthlyReport.heldConversations',
    defaultMessage: 'Held conversations',
  },
  missingReports: {
    id: 'app.containers.MonthlyReport.missingReports',
    defaultMessage: 'Missing reports',
  },
  establishedBibleStudies: {
    id: 'app.containers.MonthlyReport.establishedBibleStudies',
    defaultMessage: 'Established bible studies',
  },
  publisherHours: {
    id: 'app.containers.MonthlyReport.publisherHours',
    defaultMessage: 'Total service hours',
  },
  participatingPioneers: {
    id: 'app.containers.MonthlyReport.participatingPioneers',
    defaultMessage: 'Participating pioneers',
  },
  participatingPublishers: {
    id: 'app.containers.MonthlyReport.participatingPublishers',
    defaultMessage: 'Participating publishers',
  },
  reportsFromPreviousMonths: {
    id: 'app.containers.MonthlyReport.reportsFromPreviousMonths',
    defaultMessage: 'Reports form previous months',
  },
});
